import Skeleton from '@material-ui/lab/Skeleton'
import * as React from 'react'

import styled from 'styled-components'
import { createMuiTheme, ThemeProvider, useMediaQuery } from '@material-ui/core'

const StyledRow = styled.tr`
  width: 100%;
  border: none;

  td {
    background: linear-gradient(rgb(45, 45, 45), rgb(20, 20, 20));
    border-color: #323232;
    border-width: 1px;
    border-style: solid;
    border-left: none;
    border-right: none;
    color: white;
    font-size: 24px;
    font-weight: 700;

    @media (max-width: 62em) {
      text-align: right;
      padding-right: 15px;
    }
  }

  td:first-child {
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    border-left: 1px solid #323232;
  }

  td:last-child {
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    border-right: 1px solid #323232;
  }
`

const Subtitle = styled.div`
  color: white;
  font-weight: 500;
  font-size: 1.1rem;
`

const CreatorCell = styled.div`
  padding: 15px 0;
  padding-left: 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 25px;
  cursor: pointer;

  @media (max-width: 43em) {
    gap: 15px;
  }
`

const Rank = styled.div`
  color: white;
  font-size: 18px;
  font-weight: 700;
  text-align: left;

  @media (max-width: 43em) {
    font-size: 14px;
  }
`

const ValueCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  @media (max-width: 62em) {
    align-items: flex-end;
  }
`

const theme = createMuiTheme({
  palette: {
    type: 'dark',
  },
})

export const CreatorSkeletonItem = ({ rank }: { rank: number }): JSX.Element => {
  const isTablet = useMediaQuery('(max-width: 62em)')

  if (isTablet) {
    return (
      <ThemeProvider theme={theme}>
        <StyledRow>
          <td>
            <CreatorCell>
              <Rank>{'#' + rank}</Rank>
              <Skeleton animation="pulse" variant="circle" width={'45px'} height={'45px'} />
              <Skeleton animation="pulse" variant="text" width={'85px'} height={'20px'} />
            </CreatorCell>
          </td>
          <td>
            <ValueCell>
              <Skeleton animation="pulse" variant="text" width={'75px'} height={'20px'} />
              <Subtitle>
                <Skeleton animation="pulse" variant="text" width={'15px'} />
              </Subtitle>
            </ValueCell>
          </td>
        </StyledRow>
      </ThemeProvider>
    )
  }

  return (
    <ThemeProvider theme={theme}>
      <StyledRow>
        <td>
          <CreatorCell>
            <Rank>{'#' + rank}</Rank>
            <Skeleton animation="pulse" variant="circle" width={'60px'} height={'60px'} />
            <Skeleton animation="pulse" variant="text" width={'135px'} />
          </CreatorCell>
        </td>
        <td>
          <Skeleton animation="pulse" variant="text" width={'35px'} />
        </td>
        <td>
          <ValueCell>
            <Skeleton animation="pulse" variant="text" width={'115px'} />
            <Subtitle>
              <Skeleton animation="pulse" variant="text" width={'35px'} />
            </Subtitle>
          </ValueCell>
        </td>
        <td>
          <ValueCell>
            <Skeleton animation="pulse" variant="text" width={'115px'} />
            <Subtitle>
              <Skeleton animation="pulse" variant="text" width={'35px'} />
            </Subtitle>
          </ValueCell>
        </td>
        <td>
          <ValueCell>
            <Skeleton animation="pulse" variant="text" width={'115px'} />
            <Subtitle>
              <Skeleton animation="pulse" variant="text" width={'35px'} />
            </Subtitle>
          </ValueCell>
        </td>
      </StyledRow>
    </ThemeProvider>
  )
}

export default CreatorSkeletonItem
